import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.41074 2.74408C9.73618 2.41864 10.2638 2.41864 10.5893 2.74408L13.9226 6.07741C14.248 6.40285 14.248 6.93049 13.9226 7.25592C13.5972 7.58136 13.0695 7.58136 12.7441 7.25592L10.8333 5.34518V13.3333C10.8333 13.7936 10.4602 14.1667 10 14.1667C9.53976 14.1667 9.16667 13.7936 9.16667 13.3333V5.34518L7.25592 7.25592C6.93049 7.58136 6.40285 7.58136 6.07741 7.25592C5.75197 6.93049 5.75197 6.40285 6.07741 6.07741L9.41074 2.74408ZM3.33333 12.5C3.79357 12.5 4.16667 12.8731 4.16667 13.3333V14.1667C4.16667 14.6087 4.34226 15.0326 4.65482 15.3452C4.96738 15.6577 5.39131 15.8333 5.83333 15.8333H14.1667C14.6087 15.8333 15.0326 15.6577 15.3452 15.3452C15.6577 15.0326 15.8333 14.6087 15.8333 14.1667V13.3333C15.8333 12.8731 16.2064 12.5 16.6667 12.5C17.1269 12.5 17.5 12.8731 17.5 13.3333V14.1667C17.5 15.0507 17.1488 15.8986 16.5237 16.5237C15.8986 17.1488 15.0507 17.5 14.1667 17.5H5.83333C4.94928 17.5 4.10143 17.1488 3.47631 16.5237C2.85119 15.8986 2.5 15.0507 2.5 14.1667V13.3333C2.5 12.8731 2.8731 12.5 3.33333 12.5Z",
  fill: "#B82025"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}